<template>
  <div class="ticket">
    <div class="ticket_title">{{ ticketName }}</div>
    <div class="ticket_tips">
      <div class="ticket_tips__label">
          注意事项：
      </div>
      {{ticketNote}}
    </div>
    <!-- <div class="ticket_name">{{ ticketName }}</div>
    <div class="ticket_note">{{ ticketNote }}</div> -->
    <ul class="ticket_items">
      <li 
        class="ticket_item"
        v-for="(item, i) in ticketItems"
        :key="i"
      >
        <span class="ticket_item__name">{{ item.key + '：'}}</span>
        <span class="ticket_item__value">{{ item.value}}</span>
      </li>
    </ul>
    <img class="ticket_bg" :src="bgImage" />
  </div>
</template>

<script>
export default {
  props: {
    ticketName: String,
    ticketNote: String,
    bgImage:String,
    ticketItems: {
      type: Array,
      default:()=>([])
    },
  }
}
</script>

<style lang="less" scope>
.ticket{
  width: 595px;
  height: 842px;
  text-align: center;
  padding: 100px 40px;
  &_tips {
    margin-top: 30px;
    font-size:18px;
    color:rgba(59,59,59,1);
    line-height:25px;
    letter-spacing:2px;
    text-align: left;
    &__label {
      font-family:PingFangSC-Medium,PingFang SC;
      font-weight:500;
      width: 100px;
      display: inline-block;
      margin-left: 69px;
    }
    &__value {
      word-wrap:break-word;
    }
  }
  &_title {
    font-size:36px;
    font-family:PingFangSC-Medium,PingFang SC;
    font-weight:500;
    color:rgba(59,59,59,1);
    line-height:50px;
    letter-spacing:4px;
  }
  &_items {
  }
  &_item{
    margin-top: 20px;
    &__name {
      width:60px;
      height:25px;
      font-size:18px;
      font-family:PingFangSC-Medium,PingFang SC;
      font-weight:500;
      color:rgba(59,59,59,1);
      line-height:25px;
      letter-spacing:2px;
    }
    &__value {
      width:277px;
      border-bottom: 1px solid black;
      text-align: center;
      display: inline-block;
    }
  }
  &_bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
  }
}
</style>